var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade pe-0",
      attrs: {
        id: _vm.id,
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": _vm.ariaLabelledby,
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-slideout",
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "button",
                {
                  staticClass: "btn-close ob1-link no-decoration",
                  attrs: {
                    type: "button",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Fermer",
                  },
                  on: { click: _vm.clickHandler },
                },
                [
                  _c("span", {
                    staticClass: "icon icon-delete",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [_vm._t("default")], 2),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm.withCloseButton
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button", "data-bs-dismiss": "modal" },
                      on: { click: _vm.clickHandler },
                    },
                    [_vm._v("\n                    Fermer\n                ")]
                  )
                : _vm._e(),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }